module.exports = __webpack_public_path__ + "media/images/curriculum_pikkachan_hatena-159b44541f0ac6a16cddaf66fcf8e309.png";